import { object, string, boolean } from "yup";
import type { InferType } from "yup";

export const addRateComponentSchema = object().shape({
  name: string().required().default(""),
  code: string().required().default(""),
  archived: boolean().default(false),
  description: string().default(""),
});
export type AddRateComponentFormFields = InferType<typeof addRateComponentSchema>;
